import { Link } from '../../../../../navigation';

interface Props {
  href: string;
  children?: React.ReactNode;
}

/**
 * Needed to insert the LinkCustom element as an inline component inside a Trans component.
 */

const TranslatedInlineLink = (props: Props): JSX.Element => {
  return <Link<any> href={props.href}>{props.children}</Link>;
};

export default TranslatedInlineLink;
